const creditCardBaseElementOptions = {
  style: {
    base: {
      fontSize: '16px',
    },
  },
}

export default creditCardBaseElementOptions
